var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxTopSameDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.66667H14V2.5C14 2.22333 13.7767 2 13.5 2H8.33333V1.33333C8.33333 1.15 8.18333 1 8 1C7.81667 1 7.66667 1.15 7.66667 1.33333V2H2.5C2.22333 2 2 2.22333 2 2.5V7.66667H1.33333C1.15 7.66667 1 7.81667 1 8C1 8.18333 1.15 8.33333 1.33333 8.33333H2V13.5C2 13.7767 2.22333 14 2.5 14H7.66667V14.6667C7.66667 14.85 7.81667 15 8 15C8.18333 15 8.33333 14.85 8.33333 14.6667V14H13.5C13.7767 14 14 13.7767 14 13.5V8.33333H14.6667C14.85 8.33333 15 8.18333 15 8C15 7.81667 14.85 7.66667 14.6667 7.66667ZM13.3333 13.3333H8.33333V12.6667C8.33333 12.4833 8.18333 12.3333 8 12.3333C7.81667 12.3333 7.66667 12.4833 7.66667 12.6667V13.3333H2.66667V8.33333H3.33333C3.51667 8.33333 3.66667 8.18333 3.66667 8C3.66667 7.81667 3.51667 7.66667 3.33333 7.66667H2.66667V2.66667H7.66667V3.33333C7.66667 3.51667 7.81667 3.66667 8 3.66667C8.18333 3.66667 8.33333 3.51667 8.33333 3.33333V2.66667H13.3333V7.66667H12.6667C12.4833 7.66667 12.3333 7.81667 12.3333 8C12.3333 8.18333 12.4833 8.33333 12.6667 8.33333H13.3333V13.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTopSameDirection);
export default __webpack_public_path__ + "static/media/boxTopSameDirection.0ff3a2ce20e1a8bc4b76e60b4c169cc4.svg";
export { ForwardRef as ReactComponent };